import { Link } from "react-router-dom";
import { BRANCHES, NAV_LINKS, SOCIAL_LINKS } from "../data/siteData";
import "./Footer.css";

const toTel = (phone) =>
  /\d{6,}/.test(phone)
    ? `tel:${phone.replace(/[^\d+]/g, "")}`
    : null;

function BranchCard({
  name,
  address,
  phone,
  email,
  timings,
  mapUrl,
}) {
  const tel = phone ? toTel(phone) : null;

  return (
    <address className="branch">
      <h3>{name}</h3>

      {address && (
        <p className="branch__address">
          {address}
        </p>
      )}

      {phone && (
        <p>
          <span className="branch__label">Phone</span>
          {tel ? <a href={tel}>{phone}</a> : phone}
        </p>
      )}

      {email && (
        <p>
          <span className="branch__label">Email</span>
          {email.includes("@") && !email.startsWith("[") ? (
            <a href={`mailto:${email}`}>{email}</a>
          ) : (
            email
          )}
        </p>
      )}

      {timings && (
        <p className="branch__timings">
          <span className="branch__label">Timings</span>
          {timings}
        </p>
      )}

      {mapUrl && (
        <a
          className="branch__map"
          href={mapUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          View on map →
        </a>
      )}
    </address>
  );
}

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__grid">

        {/* ---------- Quick Links + Social ---------- */}

        <div className="footer__quick">
          <nav className="footer__links" aria-label="Quick links">
            <h3>Quick Links</h3>

            {NAV_LINKS.map(({ label, to }) => (
              <Link key={to} to={to}>
                {label}
              </Link>
            ))}
          </nav>

          {/* Social buttons */}
          <div className="footer__social">
            {SOCIAL_LINKS.map(({ label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-btn"
              >
                {label}
              </a>
            ))}
          </div>
        </div>


        {/* ---------- Branch 1 ---------- */}

        {BRANCHES[0] && (
          <BranchCard {...BRANCHES[0]} />
        )}


        {/* ---------- Branch 2 ---------- */}

        {BRANCHES[1] && (
          <BranchCard {...BRANCHES[1]} />
        )}

      </div>

      {/* ---------- Copyright ---------- */}

      <div className="footer__bottom">
        <p className="footer__copyright">
          Copyright © {new Date().getFullYear()} Agape Garden.
          All rights reserved.
        </p>
      </div>
    </footer>
  );
}